import {FC} from 'react'
import {ChooseEmployee} from 'features/procedures/ChooseEmployee'

export const Index: FC = () => {
  return <ChooseEmployee procedureType="health_insurance_qualification_confirmation" nextAction="create" />
}
